import React from "react";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

/* ===== Images ===== */
import karuna from "../TeamPhotos/Karuna Kanwar.png";
import riteeka from "../TeamPhotos/ritika mahajan.png";
import harpreet from "../TeamPhotos/Harpreet.png";
import narinder from "../TeamPhotos/narinder.png";
import sunil from "../TeamPhotos/Sunil.png";
import Priya from "../TeamPhotos/Priya.png";
import Baljit from "../TeamPhotos/Baljit Singh.png";
import Simran from "../TeamPhotos/simran.png";
import Aman from "../TeamPhotos/Aman Choudhary.png";
import Dimple_rana from "../TeamPhotos/Dimple.png";
import Arti_Kanwar from "../TeamPhotos/Arti.png";
import Vardhman_Jain from "../TeamPhotos/Vardhman.png";
import Aditya from "../TeamPhotos/aditya_Madan.jpg";
/* ===== Data ===== */
const teamMembers = [
  { imgSrc: karuna, name: "Ms. Karuna Kanwar", designation: "Chief Executive Officer", linkedin: "https://www.linkedin.com/in/karuna-kanwar-50293561/" },
  { imgSrc: Aditya, name: "Mr. Aditya Madan", designation: "Chief Partnerships Consultant", linkedin: "https://www.linkedin.com/in/madanaditya/" },
  { imgSrc: Priya, name: "Ms. Priya Kumari", designation: "Manager", linkedin: "https://www.linkedin.com/in/priya-kumari-6a3a1213a" },
  { imgSrc: Vardhman_Jain, name: "Mr. Vardhman Jain", designation: "Associate Manager", linkedin: "https://www.linkedin.com/in/vardhman-jain-75ab11245/" },
  { imgSrc: Simran, name: "Ms. Simran Kaur", designation: "Assistant Manager (Marketing & CSR)", linkedin: "https://www.linkedin.com/in/simran-kaur4578/", Mail:"mailto:pr.tbif@iitrpr.ac.in"},
  { imgSrc: Aman, name: "Mr. Aman Choudhary", designation: "Assistant Manager (Projects)", linkedin: "/" },
  // { imgSrc: riteeka, name: "Ms. Ritika Mahajan", designation: "Manager", linkedin: "https://www.linkedin.com/in/ritika-mahajan-8b6996285/" },
  { imgSrc: harpreet, name: "Ms. Harpreet Kaur", designation: "Startup Executive", linkedin: "https://www.linkedin.com/in/harpreet-k-11691b281/" },
  { imgSrc: narinder, name: "Mr. Narinder Kumar", designation: "Office Executive", linkedin: "https://www.linkedin.com/in/narinder-kumar-0407221a3/" },
  { imgSrc: Dimple_rana, name: "Ms. Dimple Rana", designation: "Accounts Executive", linkedin: "https://www.linkedin.com/in/dimple-rana-752ab2319/" },
  { imgSrc: sunil, name: "Mr. Sunil Kumar", designation: "Executive Assistant", linkedin: "https://www.linkedin.com/in/sunil-kumar-665314303/" },
  { imgSrc: Baljit, name: "Mr. Baljit Singh", designation: "MTS", linkedin: "/" },
  { imgSrc: Arti_Kanwar, name: "Ms. Arti Kanwar", designation: "Intern", linkedin: "https://www.linkedin.com/in/arti-kanwar-4b00ba401/", position: "object-top" },
  
];

function Team() {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-br from-slate-50 via-white to-blue-50/30 overflow-hidden">
      
      {/* --- ENHANCED BACKGROUND EFFECTS --- */}
      <div className="absolute inset-0 opacity-[0.015]" 
           style={{ 
             backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
           }}>
      </div>
      
      {/* Animated gradient orbs */}
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-gradient-to-br from-blue-400/20 to-cyan-300/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-gradient-to-tr from-indigo-400/15 to-blue-300/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="max-w-7xl mx-auto relative z-10">

        {/* ===== REFINED HEADING ===== */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="h-[1px] w-12 bg-gradient-to-r from-transparent to-blue-600"></div>
            <span className="text-blue-700 font-semibold uppercase tracking-[0.2em] text-[10px] px-4 py-1.5">
              The Executors
            </span>
            <div className="h-[1px] w-12 bg-gradient-to-l from-transparent to-blue-600"></div>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            Management Team
          </h2>
          
          <p className="text-slate-600 max-w-2xl mx-auto text-lg leading-relaxed">
            The driving force behind TBIF's daily operations, ensuring every startup receives 
            the mentorship, infrastructure, and support needed to succeed.
          </p>
        </div>

        {/* ===== ENHANCED TEAM GRID ===== */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl overflow-hidden border border-slate-200/60 hover:border-blue-200 transition-all duration-500 hover:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] hover:-translate-y-1"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.05}s both`
              }}
            >
              
              {/* Gradient overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50/0 via-transparent to-cyan-50/0 group-hover:from-blue-50/50 group-hover:to-cyan-50/30 transition-all duration-500 pointer-events-none"></div>

              {/* --- CIRCULAR IMAGE SECTION --- */}
              <div className="relative pt-8 pb-6 flex justify-center">
                <div className="relative w-40 h-40">
                  {/* Animated gradient ring */}
                  <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-blue-600 via-cyan-400 to-blue-600 p-[3px] animate-[spin_8s_linear_infinite] shadow-lg group-hover:shadow-xl group-hover:shadow-blue-400/30 transition-shadow duration-500">
                    <div className="w-full h-full bg-white rounded-full"></div>
                  </div>
                  
                  {/* Actual image */}
                  <div className="absolute inset-[4px] rounded-full overflow-hidden bg-slate-100">
                    <img
                      src={member.imgSrc}
                      alt={member.name}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700 ease-out"
                    />
                  </div>

                  {/* Decorative dots */}
                  {/* <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse"></div>
                  <div className="absolute -bottom-2 -left-2 w-3 h-3 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse" style={{ animationDelay: '0.5s' }}></div> */}
                </div>
              </div>

              {/* --- TEXT CONTENT --- */}
              <div className="relative p-6">
                
                {/* NAME */}
                <h3 className="text-lg font-bold text-slate-900 mb-1 group-hover:text-blue-700 transition-colors duration-300">
                  {member.name}
                </h3>
                
                {/* DESIGNATION */}
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-5">
                  {member.designation}
                </p>

                {/* --- SOCIAL LINKS --- */}
                <div className="flex items-center gap-2 pt-4 border-t border-slate-100">
                  {member.linkedin && member.linkedin !== "/" && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group/link flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-[#0077b5] transition-colors duration-300"
                      title="LinkedIn Profile"
                    >
                      <div className="p-1.5 bg-slate-50 rounded-lg group-hover/link:bg-blue-50 transition-colors duration-300">
                        <Linkedin size={14} />
                      </div>
                      <span className="hidden sm:inline">LinkedIn</span>
                      <ArrowUpRight size={12} className="opacity-0 group-hover/link:opacity-100 transition-opacity" />
                    </a>
                  )}
                  <a
                    href="mailto:tbif@iitrpr.ac.in"
                    className="group/link flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-blue-600 transition-colors duration-300 ml-auto"
                    title="Send Email"
                  >
                    <div className="p-1.5 bg-slate-50 rounded-lg group-hover/link:bg-blue-50 transition-colors duration-300">
                      <Mail size={14} />
                    </div>
                  </a>
                </div>
              </div>

              {/* Bottom accent line (visible on hover) */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Add fadeInUp animation */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}

export default Team;